import React, { Component, forwardRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Tab, Nav } from "react-bootstrap";
import Loader from "../../utils/Loader";
import { Modal, Button } from "react-bootstrap";
import { get_guideline_file_action } from "../../actions/accounts_action/guideline_action";
import { BASE_URL } from "../../utils/constants";

class bookNow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isOpen: false,ViewDocument:""
    };
  }
  async componentDidMount() {}

  toggleModal() {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
    if (!isOpen) {
      this.props
        .get_guideline_file_action()
        .then((data) => {
          if (data.error != 1) {
            if (data.data != '') {
              const url = BASE_URL.split('/api')
              const file = data.data[0]['GuideLine'].split('/document/guideline/')
              console.log("ducument--------------", url[0] + data.data[0]['GuideLine'])
              this.setState({ isLoading: false, fileName: file[1], GuidelineID: data.data[0]['GuidelineID'], existFilePath: data.data[0]['GuideLine'], ViewDocument: url[0] + data.data[0]['GuideLine'] });
            }
            this.setState({ isLoading: false });
          } else {
            this.setState({ isLoading: false });
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  render() {
    const { isOpen, isLoading,ViewDocument } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <header
            id="header"
            className="fixed-top"
            style={{ background: "#d3f6de" }}
          >
            <div className="container-fluid d-flex align-items-center">
              {/* <h1 class="logo mr-auto"><a href="index.html"><span>Com</span>pany</a></h1> */}
              <a href="index.html" className="logo mr-auto">
                <img
                  src="img/main-logo-green.png"
                  alt=""
                  className="img-fluid"
                />
              </a>
              <img
                src="img/down__2__page-0001-removebg-preview.png"
                aria-colcount=""
                alt=""
                className="img-fluid login-sec-logo"
              />
              <div>
                <img
                  src="img/right-logo-top.png"
                  aria-colcount=""
                  style={{ top: "-20px", right: "-20px" }}
                  alt=""
                  className="img-fluid login-sec-logo"
                />
                <a href="index.html" className="logo mr-auto">
                  <img src="img/right_logo.png" alt="" className="img-fluid" />
                </a>
              </div>
            </div>
          </header>
          <div
            className="dust_pattern-1 pt-5 lazy-container"
            style={{ marginTop: 86 }}
          >
            <div className="container pt-4">
              {/* <h2 class="text-center font-weight-bold mb-5">Venues Available</h2> */}
              <ul
                className="nav nav-pills mb-5 justify-content-center"
                id="pills-tab"
                role="tablist"
              >
                <li
                  className="nav-item tab-sty"
                  role="presentation"
                  style={{ minWidth: 315 }}
                >
                  <a
                    onClick={() => this.props.navigate("/viewSpecifications")}
                    style={{
                      color: "black",
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                  >
                    Venue Specifications
                  </a>
                  <span className="round_1" />
                  <span className="round_2" />
                  <span className="round_3" />
                  <span className="round_4" />
                </li>
                <li
                  className="nav-item tab-sty"
                  role="presentation"
                  style={{ minWidth: 370 }}
                >
                  <a
                    onClick={()=>this.toggleModal()}
                    style={{
                      color: "black",
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                  >
                    General information and Regulations
                  </a>
                  <span className="round_1" />
                  <span className="round_2" />
                  <span className="round_3" />
                  <span className="round_4" />
                </li>
                <li
                  className="nav-item tab-sty"
                  role="presentation"
                  style={{ minWidth: 340 }}
                >
                  <a
                    onClick={() => this.props.navigate("/normalView")}
                    className="nav-link"
                    style={{
                      width: "100%",
                      fontWeight: "normal",
                      cursor: "pointer",
                    }}
                    role="tab"
                    aria-controls="pills-contact"
                    aria-selected="false"
                  >
                    Availability of Booking
                  </a>
                  <span className="round_1" />
                  <span className="round_2" />
                  <span className="round_3" />
                  <span className="round_4" />
                </li>
              </ul>
              <br />
              <br />
            </div>
          </div>
          <Modal
            // size="xl"
            dialogClassName="modal-70w"
            show={isOpen}
            aria-labelledby="example-custom-modal-styling-title"
          >
            <Modal.Body className="p-0">
              <iframe
                className="mb-n2"
                id="myIframe"
                src={ViewDocument}
                width="100%"
                height="650px"
                title="Bing"
              ></iframe>
            </Modal.Body>
            <Modal.Footer className="p-0">
              <button
                // style={{ scale: "0.85" }}                    
                onClick={() => this.toggleModal()}
                class="btn btn-secondary ml-2"
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>
          <footer style={{ backgroundColor: "#d3f6de" }}>
            <div
              className="container-fluid py-2  px-5 footer-text"
              style={{ position: "relative", zIndex: 5 }}
            >
              <div className="row mt-3">
                <div className="col-lg-9">
                  <div className="d-md-flex align-items-center">
                    <a href="AboutITME.aspx">
                      <img
                        src="https://itmecenter.in/images/footer-green.png"
                        style={{ maxWidth: 160 }}
                      />
                    </a>
                    <h3
                      style={{ fontSize: 25, fontWeight: "bold" }}
                      className="pl-md-4 py-3 py-md-0  footer-india"
                    >
                      India International Textile Machinery Exhibitions Society
                    </h3>
                  </div>
                </div>
                <div className="col-lg-3 d-flex justify-content-end ">
                  <div className="social-svg">
                    <div className="svg-social">
                      <a
                        target="_blank"
                        href="https://www.facebook.com/itmecenterindia?mibextid=ZbWKwL"
                      >
                        <i
                          className="fa fa-facebook social-svg-icon social-svg-facebook"
                          style={{ color: "#007bff" }}
                        />
                      </a>
                    </div>
                    <div className="svg-social">
                      {" "}
                      <a
                        target="_blank"
                        href="https://www.instagram.com/itmecenterindia/?igsh=MTRtcXB3ZmtieWN0"
                      >
                        <i
                          className="fa fa-instagram social-svg-icon"
                          style={{ color: "#007bff" }}
                        />
                      </a>
                    </div>
                    <div className="svg-social">
                      {" "}
                      <a
                        target="_blank"
                        href="https://www.linkedin.com/company/itme-center/"
                      >
                        <i
                          className="fa fa-linkedin social-svg-icon"
                          style={{ color: "#007bff" }}
                        />
                      </a>
                    </div>
                    <div className="svg-social">
                      <a
                        target="_blank"
                        href="https://www.youtube.com/@ITMECenterIndia?si=YIsOQETPTIKRFq8O"
                      >
                        <i
                          className="fa fa-youtube-play social-svg-icon"
                          style={{ color: "#007bff" }}
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-2 ">
                <div className="col-lg-5 col-md-6  contact_div">
                  <div
                    className="svg-1"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "1.5rem",
                    }}
                  >
                    <div className="svg">
                      <i className="fas fa-map-marker-alt" />
                    </div>
                    <h6 className="mb-3 one-line-footer">
                      <span style={{ textIndent: "-12px" }}>
                        {" "}
                        <i className="fa fa-map-marker" /> &nbsp;1210/1211/1212
                        Dalamal Tower, ‘A’ Wing, 12th Floor, Plot No.211,
                        Nariman Point, Mumbai – 400 021, INDIA
                      </span>
                    </h6>
                  </div>
                  <div className="svg-1">
                    <h6 className="mb-3">
                      <span>
                        <a
                          style={{ color: "black", textDecoration: "none" }}
                          href="tel:+912249724603"
                        >
                          <i className="fa fa-phone" /> +91-22-49724603
                        </a>
                      </span>
                    </h6>
                  </div>
                  <div className="svg-1">
                    <h6 className="mb-3">
                      <span>
                        <a
                          style={{ color: "black", textDecoration: "none" }}
                          href="tel:+918591951769"
                        >
                          <i className="fa fa-mobile" /> +91-85919 51769
                        </a>
                      </span>
                    </h6>
                  </div>
                  <div className="svg-1">
                    <h6 className="mb-3">
                      <a
                        style={{ color: "black", textDecoration: "none" }}
                        target="_blank"
                        href="//api.whatsapp.com/send?phone=977021089987"
                      >
                        <i className="fa fa-whatsapp" /> +97-70210 89987
                      </a>
                    </h6>
                  </div>
                  <div className="svg-1">
                    <h6 className="mb-3">
                      <p className="mb-0">
                        <a
                          style={{ color: "black", textDecoration: "none" }}
                          href="mailto:contact@itmecenter.in"
                        >
                          <i className="fa fa-envelope-o" />{" "}
                          contact@itmecenter.in
                        </a>{" "}
                        /{" "}
                        <a
                          style={{ color: "black", textDecoration: "none" }}
                          href="mailto:itme@india-itme.com"
                        >
                          itme@india-itme.com
                        </a>
                      </p>
                    </h6>
                  </div>
                </div>
                <div
                  className="col-lg-3 col-md-12  mt-4 mt-lg-0 contact_div"
                  style={{ borderRight: "2px solid black" }}
                >
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3774.1575751101454!2d72.82182580992911!3d18.92441815664134!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7d1eec807af1b%3A0x2addede9776ec83!2sIndia%20ITME%20Society!5e0!3m2!1sen!2sin!4v1684486283840!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
                <div className="col-lg-4 col-md-6 pl-lg-5 mt-4 mt-lg-0  quicklink footer-about-venue">
                  <ul className="row footer-3row ">
                    <li className="col-md-6 mb-3">
                      <a className="nav-link" href="AboutITME.aspx">
                        About us <span className="sr-only">(current)</span>
                      </a>
                    </li>
                    <li className="col-md-6 mb-3 pl-3 text-lg-right">
                      <a className="nav-link" href="Venue.aspx">
                        Venue <span className="sr-only">(current)</span>
                      </a>
                    </li>
                    <li className="col-md-6 mb-3">
                      <a className="nav-link" href="Suitability.aspx">
                        Suitability<span className="sr-only">(current)</span>
                      </a>
                    </li>
                    <li className="col-md-6 mb-3 pl-3 text-lg-right">
                      <a className="nav-link" href="Contact_us.aspx">
                        Contact us <span className="sr-only">(current)</span>
                      </a>
                    </li>
                    <li className="col-md-6 mb-3 ">
                      <a className="nav-link" href="Events_Gallery.aspx">
                        Events Gallery{" "}
                        <span className="sr-only">(current)</span>
                      </a>
                    </li>
                    <li className="col-md-6 text-lg-right mb-3 ">
                      <a className="nav-link" href="Privacy-Policy.aspx">
                        Privacy Policy{" "}
                        <span className="sr-only">(current)</span>
                      </a>
                    </li>
                  </ul>
                  <div className="d-none">
                    <div className="d-flex align-items-center email-box">
                      <input
                        name="ctl00$txt"
                        type="text"
                        id="ctl00_txt"
                        className="form-control "
                        placeholder="Your Email"
                        style={{ borderRadius: 0, height: 41 }}
                      />
                      <input
                        type="submit"
                        name="ctl00$Button1"
                        defaultValue="Submit"
                        id="ctl00_Button1"
                        className="btn-yellow btn-yellow-master"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </footer>
          <section style={{ backgroundColor: "#505050" }}>
            <div className="container py-3">
              <p
                style={{ marginBottom: 0, color: "white", fontSize: 16 }}
                className="pb-0 text-center"
              >
                Ownership: All content and images used on this site are owned or
                licensed by India ITME Society. You may not copy, reproduce,
                distribute, publish, display, perform, modify, create derivative
                works, transmit, or in any other way exploit any part of
                copyrighted material without permission of the copyright owner.
                Failure to comply shall result in legal action.
              </p>
            </div>
          </section>
        </>
      </>
    );
  }
}
export default withRouter(connect(null, {get_guideline_file_action})(bookNow));
